import { getIndustryQueryParams } from "app/pages/industry-analysis/common/getQueryParams";

export const getPlayersQueryParams = () => {
    const queryParams = getIndustryQueryParams();
    return queryParams;
};
